//#region src/payment/provider.ts
/**
* @see PaymentProvider in prisma/models/payments.prisma, must add new row before adding to this enum
*/
const PaymentProvider = {
	internal: "internal",
	stripe: "stripe",
	onerway: "onerway",
	gmo: "gmo",
	airwallex: "airwallex",
	paypay: "paypay",
	antom: "antom",
	apple: "apple",
	apple2: "apple2",
	paddle: "paddle",
	braintree: "braintree",
	google: "google",
	google2: "google2",
	google3: "google3",
	mock: "mock"
};
const webProviders = [
	PaymentProvider.onerway,
	PaymentProvider.paypay,
	PaymentProvider.gmo,
	PaymentProvider.antom
];
const mobileProviders = [PaymentProvider.apple2, PaymentProvider.google3];
const deprecatedWebProviders = [
	PaymentProvider.stripe,
	PaymentProvider.airwallex,
	PaymentProvider.paddle,
	PaymentProvider.braintree
];
const isDeprecatedPaymentProvider = (provider) => deprecatedWebProviders.includes(provider);
const PaymentProviders = Object.keys(PaymentProvider);
//#endregion
export { PaymentProvider, PaymentProviders, deprecatedWebProviders, isDeprecatedPaymentProvider, mobileProviders, webProviders };
